import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { prop } from 'ramda';
import { changeSubscriptionRange } from '@olxbr/mojo-jojo/actions/product';
import { getPOSData } from '@olxbr/mojo-jojo/selectors/pos';
import { getAdData } from '@olxbr/mojo-jojo/selectors/ad';

import { selectSubscriptionRange } from '../../core/services/tracking';
import Dropdown from './Dropdown';


const getAdId = prop('legacyAdId');
const getListId = prop('listId');
const getName = prop('name');
const getFunnelId = prop('funnelId');

const mapStateToProps = state => ({
  adId: getAdId(getAdData(state)),
  listId: getListId(getAdData(state)),
  pointOfSale: getName(getPOSData(state)),
  funnelId: getFunnelId(getPOSData(state)),
});

const mapDispatchToProps = ({ changeSubscriptionRange });

const configureHandlers = withHandlers({
  onSelect: ({
    adId,
    listId,
    pointOfSale,
    funnelId,
    ...props
  }) => (value) => {
    selectSubscriptionRange({
      adId, listId, pointOfSale, select: value, funnelId,
    });
    props.changeSubscriptionRange(value);
  },
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  configureHandlers,
)(Dropdown);
